import { isEmptyOrNil } from '@mediatool/mt-utils/import'

const optionalProp = (key, value) => (isEmptyOrNil(value) ? {} : { [key]: value })

const toJobTitle = (jobTitle) => (jobTitle === 'Other title' ? undefined : jobTitle?.trim())

export const getActivateUserData = (values) => ({
  firstName: values.firstName,
  lastName: values.lastName,
  employedBy: values.employedBy,
  ...optionalProp('jobTitle', toJobTitle(values.jobTitle)),
  ...optionalProp('jobTitleDescriptors', values.jobTitleDescriptors),
  ...optionalProp('image', values.image),
})
